import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import AlarmCard from "./Card";
import { getSocket, leaveSurface } from "Utilities/socket";

export default function Alarms(props) {
  // Realtime Phase C (2026-08-06): subscribe the per-device alarms channel
  // ONCE at the tab level (the four severity Cards all listen on
  // emitter("asset?alarms"), fed by the Asset View parent dispatcher — a
  // per-Card subscription would break siblings on partial unmount under the
  // per-surface REPLACE registry). Topic is un-tenant'd (server appends
  // __<tenant>); deps re-subscribe on in-place asset switches (the
  // PrivateRoute component->render fix means no remount).
  useEffect(() => {
    if (!props.serviceId || !props.id) return;
    getSocket([`alarms__${props.serviceId}__${props.id}`], "assetAlarms");
    return () => {
      leaveSurface("assetAlarms");
    };
  }, [props.id, props.serviceId]);

  return (
    <div
      style={{
        height: 'calc(100vh - 238px)',
        minHeight: 'calc(100vh - 300px)',
        overflowY: "scroll",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <Grid container>
        {[
          { type: "CRITICAL", label: "CRITICAL", color: "#bf3535" },
          { type: "MAJOR", label: "MAJOR", color: "#844204" },
          { type: "MINOR", label: "MINOR", color: "#ffa320" },
          { type: "WARNING", label: "INFO", color: "#3399ff" },
        ].map((elm) => (
          <Grid item xs={12} sm={6} md={6}>
            <AlarmCard
              permission={props.permission}
              type={elm.type}
              id={props.id}
              color={elm.color}
              mode={props.mode}
              serviceId={props.serviceId}
              sensors={props.sensors}
              label={elm.label}
              dashboardView={props.dashboardView}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
